var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHistoryIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.758 0.634766C2.37888 0.634766 2.88221 1.13763 2.88221 1.75795V6.87621H8.00513C8.62602 6.87621 9.12934 7.37908 9.12934 7.99939C9.12934 8.61971 8.62602 9.12258 8.00513 9.12258H1.758C1.13712 9.12258 0.633789 8.61971 0.633789 7.99939V1.75795C0.633789 1.13763 1.13712 0.634766 1.758 0.634766Z",
    fill: "#B08C3D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.2231 0.674637C14.9911 0.501181 17.7371 1.26218 20.0202 2.83542C22.3032 4.40865 23.9908 6.70284 24.8119 9.34952C25.633 11.9962 25.54 14.8418 24.5478 17.4293C23.5555 20.0168 21.7217 22.1961 19.3408 23.6171C16.9598 25.0382 14.1699 25.6185 11.4192 25.265C8.66842 24.9114 6.1164 23.6445 4.17297 21.6677C2.22954 19.6908 1.00749 17.1188 0.703063 14.3646C0.634912 13.7481 1.07995 13.193 1.69708 13.1249C2.31422 13.0569 2.86975 13.5015 2.9379 14.1181C3.18698 16.3716 4.1869 18.4761 5.77705 20.0936C7.36721 21.711 9.45533 22.7477 11.7061 23.037C13.9568 23.3262 16.2395 22.8514 18.1877 21.6887C20.1358 20.5259 21.6363 18.7428 22.4482 16.6256C23.26 14.5085 23.3361 12.1802 22.6643 10.0146C21.9924 7.84901 20.6116 5.97186 18.7436 4.6846C16.8755 3.39734 14.6287 2.77468 12.3638 2.9166C10.0997 3.05849 7.9489 3.95628 6.25671 5.46585C6.25621 5.46629 6.25572 5.46674 6.25522 5.46718L2.51007 8.83476C2.04857 9.24973 1.33774 9.21235 0.92239 8.75127C0.50704 8.29019 0.544452 7.58001 1.00595 7.16504L4.75736 3.79185C6.82576 1.94593 9.45509 0.848093 12.2231 0.674637Z",
    fill: "#B08C3D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.0031 6.6875C13.624 6.6875 14.1273 7.19037 14.1273 7.81069V13.358L18.5036 15.5441C19.0589 15.8215 19.284 16.4962 19.0063 17.051C18.7287 17.6058 18.0534 17.8307 17.4981 17.5533L12.5004 15.0567C12.1195 14.8665 11.8789 14.4776 11.8789 14.0521V7.81069C11.8789 7.19037 12.3822 6.6875 13.0031 6.6875Z",
    fill: "#B08C3D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHistoryIcon);
export default __webpack_public_path__ + "static/media/history-icon.bab145f6b38b798f05421988c0fc95b2.svg";
export { ForwardRef as ReactComponent };